import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { RegistrationData } from '../types/RegistrationData';
import { removeUndefined } from './firestoreUtils';

const saveUserDetails = async (userId: string, userDetails: RegistrationData) => {
    try {
      const userDocRef = doc(db, "users", userId);

      const cleanUserDetails = removeUndefined({
        ...userDetails,
        userId, // ensure it's there
      });
  
      await setDoc(userDocRef, cleanUserDetails);
    } catch (error) {
      console.error('Error saving user details:', error);
    }
};

export {saveUserDetails}